import { useHistory } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { apisiseci } from "../../../../../../api";
import { AxiosError } from "axios";
import { AttendanceLocalDepartmentQueueServiceTimeComplement } from "../../../../../../../@types/attendance-local-department-queue-service-time-complement";

export type AttendanceLocalDepartmentQueueServiceTimeComplementCreateData = Pick<
    AttendanceLocalDepartmentQueueServiceTimeComplement,
    | "fila"
    | "tempo"
> & {
    servico: number;
};

export function useAttendanceLocalDepartmentQueueServiceTimeComplementCreate() {
    const history = useHistory();
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation({
        mutationKey: ["attendance-local", "department", "queue", "service-time-complement", "create"],
        mutationFn: async (data: AttendanceLocalDepartmentQueueServiceTimeComplementCreateData) => {
            const response = await apisiseci.post<AttendanceLocalDepartmentQueueServiceTimeComplement>(
                '/cms/tempo_servico_complementar_fila/', data,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ['attendance-local', 'department', 'queue', 'service-time-complement', 'list']
            });

            toast.success("Tempo de serviço complementar criado com sucesso!");
            history.replace({
                pathname: history.location.pathname.replace(/\/novo$/, ""),
                state: { showSuccessAlert: true }
            });
        },
        onError: (error: AxiosError<{ detail: string }>) => {
            toast.error(
                error?.response?.data?.detail || "Algo deu errado, tente novamente!"
            );
            console.log(error);
        },
    });

    return mutation;
}
